var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellerDashboardCreatestudy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 152,
    viewBox: "0 0 408 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2426_51513)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2426_51513)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407.5,
    height: 175,
    transform: "translate(0.5 0.5)",
    fill: "url(#paint0_linear_2426_51513)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33,
    filter: "url(#filter0_d_2426_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 -15.5C66.5 -18.8137 69.1863 -21.5 72.5 -21.5H418.5C421.814 -21.5 424.5 -18.8137 424.5 -15.5V23.5C424.5 26.8137 421.814 29.5 418.5 29.5H72.5C69.1863 29.5 66.5 26.8137 66.5 23.5V-15.5Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: -15.5,
    width: 39,
    height: 39,
    rx: 4,
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 12,
    width: 54,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2426_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.517 -2.37242C376.136 -2.37255 375.748 -2.13575 375.517 -1.66442L374.101 1.25071L370.874 1.70878C369.836 1.85318 369.5 2.87145 370.249 3.60345L372.581 5.87345L372.04 9.05945C371.862 10.0908 372.717 10.7141 373.643 10.2254C374.001 10.0361 375.841 9.08278 376.517 8.72612L379.39 10.2254C380.318 10.7141 381.176 10.0914 380.994 9.05945L380.431 5.87345L382.764 3.60345C383.517 2.87412 383.198 1.85611 382.16 1.70878L378.911 1.25071L377.516 -1.66442C377.286 -2.13595 376.897 -2.37222 376.517 -2.37242Z",
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.364 9.64C397.767 9.64 397.211 9.528 396.698 9.304C396.194 9.07067 395.783 8.73933 395.466 8.31C395.158 7.88067 394.985 7.37667 394.948 6.798H396.586C396.679 7.18067 396.885 7.484 397.202 7.708C397.519 7.932 397.907 8.044 398.364 8.044C398.691 8.044 398.989 7.96933 399.26 7.82C399.531 7.66133 399.741 7.45133 399.89 7.19C400.049 6.91933 400.128 6.62533 400.128 6.308C400.128 5.96267 400.049 5.65467 399.89 5.384C399.741 5.11333 399.531 4.90333 399.26 4.754C398.989 4.59533 398.691 4.516 398.364 4.516C398.047 4.516 397.748 4.572 397.468 4.684C397.188 4.78667 396.969 4.93133 396.81 5.118H395.382L395.83 -0.300001H401.178V1.24H397.3L397.062 3.634C397.23 3.48467 397.454 3.368 397.734 3.284C398.023 3.19067 398.308 3.144 398.588 3.144C399.204 3.144 399.755 3.27467 400.24 3.536C400.735 3.79733 401.117 4.17067 401.388 4.656C401.668 5.14133 401.808 5.70133 401.808 6.336C401.808 6.94267 401.654 7.498 401.346 8.002C401.047 8.506 400.632 8.90733 400.1 9.206C399.577 9.49533 398.999 9.64 398.364 9.64Z",
    fill: "#BEC6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2426_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 41.5C66.5 38.1863 69.1863 35.5 72.5 35.5H418.5C421.814 35.5 424.5 38.1863 424.5 41.5V82.5C424.5 85.8137 421.814 88.5 418.5 88.5H72.5C69.1863 88.5 66.5 85.8137 66.5 82.5V41.5Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 42.5,
    width: 39,
    height: 39,
    rx: 4,
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 46,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 58,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 70,
    width: 54,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5 55.5C313.5 51.0817 317.082 47.5 321.5 47.5H408.5V76.5H313.5V55.5Z",
    fill: "#F6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.499 55.3021C328.593 55.3021 327.807 55.7368 327.186 56.3855C326.283 56.3655 325.405 56.6041 324.769 57.2395C324.134 57.8748 323.895 58.7535 323.915 59.6561C323.266 60.2768 322.832 61.0628 322.832 61.9688C322.832 62.8748 323.266 63.6608 323.915 64.2815C323.895 65.1841 324.134 66.0628 324.769 66.6981C325.405 67.3335 326.283 67.5728 327.186 67.5521C327.807 68.2008 328.593 68.6355 329.499 68.6355C330.405 68.6355 331.191 68.2008 331.811 67.5521C332.714 67.5721 333.593 67.3335 334.228 66.6981C334.863 66.0628 335.102 65.1841 335.082 64.2815C335.731 63.6608 336.165 62.8748 336.165 61.9688C336.165 61.0628 335.731 60.2768 335.082 59.6561C335.102 58.7535 334.863 57.8748 334.228 57.2395C333.592 56.6041 332.714 56.3648 331.811 56.3855C331.191 55.7368 330.405 55.3021 329.499 55.3021ZM331.499 59.9688C331.669 59.9688 331.848 60.0261 331.978 60.1561C332.238 60.4168 332.238 60.8541 331.978 61.1148L329.311 63.7815C329.051 64.0415 328.613 64.0415 328.353 63.7815L327.019 62.4481C326.759 62.1875 326.759 61.7501 327.019 61.4895C327.28 61.2295 327.717 61.2295 327.978 61.4895L328.832 62.3435L331.019 60.1561C331.15 60.0261 331.328 59.9688 331.499 59.9688Z",
    fill: "#4051EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.39 57.7L346.022 64.882L348.654 57.7H350.376L346.694 67.5H345.336L341.64 57.7H343.39ZM357.579 57.7V59.268H353.449V61.578H357.145V63.146H353.449V65.932H357.579V67.5H351.811V57.7H357.579ZM359.488 57.7H363.156C363.707 57.7 364.211 57.8307 364.668 58.092C365.135 58.344 365.499 58.6987 365.76 59.156C366.031 59.604 366.166 60.0893 366.166 60.612C366.166 61.2 366.04 61.718 365.788 62.166C365.545 62.6047 365.195 62.95 364.738 63.202C364.29 63.4447 363.777 63.566 363.198 63.566H361.126V67.5H359.488V57.7ZM362.134 62.852H363.968L366.978 67.5H364.99L362.134 62.852ZM363.114 61.998C363.385 61.998 363.627 61.9373 363.842 61.816C364.057 61.6947 364.22 61.5313 364.332 61.326C364.453 61.1113 364.514 60.878 364.514 60.626C364.514 60.3647 364.453 60.1313 364.332 59.926C364.211 59.7207 364.043 59.562 363.828 59.45C363.623 59.338 363.385 59.282 363.114 59.282H361.126V61.998H363.114ZM369.992 57.7V67.5H368.354V57.7H369.992ZM378.052 57.7V59.268H373.922V61.802H377.618V63.37H373.922V67.5H372.284V57.7H378.052ZM381.339 57.7V67.5H379.701V57.7H381.339ZM389.399 57.7V59.268H385.269V61.578H388.965V63.146H385.269V65.932H389.399V67.5H383.631V57.7H389.399ZM394.528 57.7C395.443 57.7 396.273 57.91 397.02 58.33C397.767 58.75 398.355 59.3333 398.784 60.08C399.213 60.8173 399.428 61.6433 399.428 62.558C399.428 63.482 399.213 64.322 398.784 65.078C398.355 65.834 397.767 66.4267 397.02 66.856C396.273 67.2853 395.443 67.5 394.528 67.5H391.308V57.7H394.528ZM394.64 65.932C395.228 65.932 395.755 65.7873 396.222 65.498C396.698 65.1993 397.071 64.7933 397.342 64.28C397.613 63.7667 397.748 63.1927 397.748 62.558C397.748 61.9327 397.613 61.368 397.342 60.864C397.071 60.36 396.698 59.968 396.222 59.688C395.755 59.408 395.228 59.268 394.64 59.268H392.946V65.932H394.64Z",
    fill: "#4051EC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33,
    filter: "url(#filter2_d_2426_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 100.5C66.5 97.1863 69.1863 94.5 72.5 94.5H418.5C421.814 94.5 424.5 97.1863 424.5 100.5V139.5C424.5 142.814 421.814 145.5 418.5 145.5H72.5C69.1863 145.5 66.5 142.814 66.5 139.5V100.5Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 100.5,
    width: 39,
    height: 39,
    rx: 4,
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 104,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 116,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 128,
    width: 54,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2426_51513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.517 113.628C375.136 113.627 374.748 113.864 374.517 114.336L373.101 117.251L369.874 117.709C368.836 117.853 368.5 118.871 369.249 119.603L371.581 121.873L371.04 125.059C370.862 126.091 371.717 126.714 372.643 126.225C373.001 126.036 374.841 125.083 375.517 124.726L378.39 126.225C379.318 126.714 380.176 126.091 379.994 125.059L379.431 121.873L381.764 119.603C382.517 118.874 382.198 117.856 381.16 117.709L377.911 117.251L376.516 114.336C376.286 113.864 375.897 113.628 375.517 113.628Z",
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.822 122.28L397.308 115.7H399.17L395.866 121.916H401.494V123.4H393.822V122.28ZM398.694 119.158H400.332V125.5H398.694V119.158Z",
    fill: "#BEC6FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2426_51513",
    x: 57.5,
    y: -30.5,
    width: 388,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2426_51513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2426_51513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2426_51513",
    x: 37.5,
    y: 15.5,
    width: 418,
    height: 113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2426_51513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2426_51513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2426_51513",
    x: 57.5,
    y: 85.5,
    width: 388,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2426_51513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2426_51513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2426_51513",
    x1: 407.5,
    y1: -0.00000102962,
    x2: 171.105,
    y2: 305.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FFEAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2426_51513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407.5,
    height: 150.712,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2426_51513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407.5,
    height: 175,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2426_51513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.5,
    y: -6.5,
    width: 34,
    height: 21,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2426_51513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.5,
    y: 109.5,
    width: 35,
    height: 21,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerDashboardCreatestudy);
export default __webpack_public_path__ + "static/media/seller_dashboard_createstudy.2e578396cb73dcae4aeaeec1271f6800.svg";
export { ForwardRef as ReactComponent };